// 准考证路由

// const AdmissionTicket = r => require.ensure(
//   [],
//   () => r(require('@/components/admission-ticket/admission-ticket.vue')),
//   'AdmissionTicket'
// )
const NewAdmissionTicket = r => require.ensure(
  [],
  () => r(require('@/components/bloom-task/admissionTicket/AdmissionTicket.vue')),
  'AdmissionTicket'
)
export default [
  // 准考证首页
  {
    path: '/TaskSublist/admission',
    name: 'AdmissionTicket',
    component: NewAdmissionTicket,
    meta: {
      title: '准考证'
    }
  },
  {
    path: '/TaskSublist/newAdmission',
    name: 'NewAdmissionTicket',
    component: NewAdmissionTicket,
    meta: {
      title: '准考证'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/sub-route/admission-ticket.js